import { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { ChevronLeft, FileX } from 'lucide-react'
import { useT } from '@/i18n'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn, FetchParams } from '@/components/DataTable/types'
import { fetchRejectedLegal, type AdminLegalRequest } from '@/lib/adapters'
import { PERMISSIONS } from '@/lib/permissions'

/**
 * A19.12 — Rad etilgan huquqiy so'rovlar. GET /admin/legal, status=rejected
 * (client-side filtr). Rad-izohi (resolution) bilan.
 */
export function LegalRejected() {
  const t = useT()

  const columns = useMemo<AdminColumn<AdminLegalRequest>[]>(
    () => [
      { key: 'id', header: t.col.id, type: 'id', width: 70 },
      { key: 'kind', header: t.legal.kind, type: 'text', width: 130 },
      { key: 'authority', header: t.legal.authority, type: 'text', minWidth: 150 },
      { key: 'jurisdiction', header: t.legal.jurisdiction, type: 'text', width: 120 },
      { key: 'resolution', header: t.common.reason, type: 'longtext', minWidth: 160 },
      { key: 'resolved_at', header: t.col.time, type: 'date', width: 160 },
    ],
    [t],
  )

  const fetcher = useCallback((params: FetchParams) => fetchRejectedLegal(params), [])

  return (
    <>
      <PageHeader
        title={t.legal.rejectedTitle}
        screenId="A19.12"
        actions={
          <Link
            to="/legal"
            className="inline-flex items-center gap-1 rounded-md border border-border-default bg-surface-2 px-2.5 py-1 text-sm text-secondary hover:text-primary"
          >
            <ChevronLeft size={13} />
            {t.legal.queue}
          </Link>
        }
      />
      <DataTable<AdminLegalRequest>
        screenId="A19.12"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        emptyState={{ icon: <FileX size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
